import { useCallback, useContext } from 'react';
import { isNil, type LoggingChannel } from 'shared/src/utils';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import { useGoodsDetail } from '../queries/useGoodsDetail';
import { useGoodsBasic } from '../queries/useGoodsBasic';
import { GoodsParamsContext } from '../context/GoodsParamsContext';

export const useLogGoodsAnalyticsEvent = () => {
  const { data: goodsDetail } = useGoodsDetail();
  const { data: goodsBasic } = useGoodsBasic();
  const injected = useContext(GoodsParamsContext);
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback<
    (params: {
      name: string;
      channel?: Array<LoggingChannel>;
      analytics?: Record<string, unknown>;
    }) => boolean
  >(
    params => {
      // 찜탭 등 route 밖에서는 PDP 데이터를 로드하지 않으므로(카드 데이터로 대체 주입) 게이트를 건너뛴다.
      if (isNil(injected?.logging)) {
        if (isNil(goodsDetail)) return false;
        if (isNil(goodsBasic)) return false;
      }

      logAnalyticsEvent({
        name: params.name,
        channel: params.channel ?? [
          'firebase',
          'facebook',
          'amplitude',
          'ablylog',
        ],
        analytics: {
          // 찜탭 등 route 밖 진입은 AnalyticsContext(SCREEN)가 닿지 않으므로 직접 주입.
          // 주입값이 없으면(PDP) 상세 화면(GOODS_DETAIL)을 기본값으로.
          SCREEN: injected?.logging ? injected.logging.screen : 'GOODS_DETAIL',
          ...params.analytics,
          EVENT_TYPE: params.name,
        },
      });

      return true;
    },
    [goodsDetail, goodsBasic, injected, logAnalyticsEvent],
  );
};
